export default __webpack_public_path__ + "static/media/Guitars_02.fc00faa2.png";